import React from "react";
import trybzLogo from "../../../../../../../assets/logo.png";
import moment from "moment";
import { ReceiptTemplateTypes } from "../../../../../../../enum/PaymentsViewComponentsType";
import BulletPointsComp from "./components/BulletPointSectionComp";
import ItemizedTableComp from "./components/ItemizedTableComp";
import ParagraphSectionComp from "./components/ParagraphSectionComp";

export default function ManualReceiptTemplate({ receiptDetails }) {
  return (
    <section className="container tw-bg-white tw-p-4">
      <div
        className="tw-space-y-6 tw-text-black"
        style={{ paddingTop: "10px" }}
      >
        <div className="invoice-container tw-mb-[60px] tw-flex tw-items-center tw-justify-between">
          <img
            style={{
              width: 130,
              height: 110,
              objectFit: "contain",
              objectPosition: "left",
            }}
            src={trybzLogo}
            alt="trybz_logo"
          />
          <div
            className="tw-font-semibold"
            style={{
              fontSize: "40px",
              placeSelf: "center",

              color: "black",
            }}
          >
            RECEIPT
          </div>
        </div>
        <div className="tw-mb-[15px] tw-flex-wrap tw-justify-between tw-space-y-6 md:tw-flex md:tw-space-y-0">
          <div className="  tw-font-medium" style={{ display: "block" }}>
            <h3 className="tw-pb-3 tw-font-semibold tw-text-black">FROM:</h3>
            <div style={{ paddingBottom: "5px" }}>
              {receiptDetails.receivedBy.name}
            </div>
            <div style={{ paddingBottom: "5px" }}>
              {receiptDetails.receivedBy.email}
            </div>
            <div style={{ paddingBottom: "5px" }}>
              {receiptDetails.receivedBy.phoneNumber}
            </div>
          </div>

          <div className=" tw-font-medium" style={{ display: "block" }}>
            <h3 className="tw-pb-3  tw-font-semibold tw-text-black">TO:</h3>
            <div style={{ paddingBottom: "5px" }}>
              {receiptDetails.recipient.name}
            </div>
            <div style={{ paddingBottom: "5px" }}>
              {receiptDetails.recipient.email}
            </div>
          </div>

          <div
            style={{
              display: "block",
              marginBottom: "20px",
              textAlign: "right",
              color: "black",
            }}
          >
            <div className="  tw-font-medium" style={{ paddingBottom: "10px" }}>
              <div style={{ paddingBottom: "5px" }}>
                RECEIPT #: {receiptDetails.receiptNumber}
              </div>
              <div style={{ paddingBottom: "5px" }}>
                RECEIPT DATE:{" "}
                {moment(receiptDetails.issuedAt).format("DD MMM YY")}
              </div>
              <div style={{ paddingBottom: "5px" }}>
                DUE DATE: {moment(receiptDetails.dueDate).format("DD MMM YY")}
              </div>
            </div>
            <p className="tw-mt-12 tw-text-lg tw-font-semibold">AMOUNT DUE:</p>
            <p className="tw-text-4xl tw-font-semibold">
              N{receiptDetails.amount}
            </p>
          </div>
        </div>

        {/* template type based receipt content */}
        {receiptDetails.template.fieldOption ===
        ReceiptTemplateTypes.bulletPoints ? (
          <BulletPointsComp invoiceDetails={receiptDetails} />
        ) : receiptDetails.template.fieldOption ===
          ReceiptTemplateTypes.itemizedTable ? (
          <ItemizedTableComp invoiceDetails={receiptDetails} />
        ) : receiptDetails.template.fieldOption ===
          ReceiptTemplateTypes.paragraph ? (
          <ParagraphSectionComp invoiceDetails={receiptDetails} />
        ) : (
          <p>Oops! Invalid Template type provided.</p>
        )}

        <div style={{ paddingBottom: "20px" }} className="bottom">
          <div className="invoice-container" style={{ paddingTop: "30px" }}>
            <div>
              <div className="tw-font-semibold">ISSUED BY:</div>
              <div
                className="tw-font-semibold"
                style={{
                  fontSize: "24px",
                  paddingTop: "5px",
                }}
              >
                {receiptDetails.receivedBy.name}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
